import defaultAvatar from "../../../assets/sampleAvatar.png";

export default function FollowingNotification({
  senderUsername = "Unknown",
  senderAvatar,
  timeAgo = "",
  isUnread = false,
  connectionStatus = "not_connected",
  onFollowBack,
}) {
  const avatar = senderAvatar || defaultAvatar;
  const isFollowing = connectionStatus === "followed";

  const cardStyle = {
    backgroundColor: isUnread ? "rgba(60, 50, 80, 0.75)" : "rgba(50, 43, 64, 0.6)",
    border: isUnread
      ? "1px solid rgba(185, 151, 255, 0.45)"
      : "1px solid rgba(185, 151, 255, 0.15)",
    borderRadius: "20px",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    backdropFilter: "blur(10px)",
    transition: "background-color 0.2s ease",
  };

  const avatarWrapperStyle = {
    minWidth: "40px",
    maxWidth: "40px",
    height: "40px",
  };

  const avatarImgStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
  };

  const textContainerStyle = {
    flex: 1,
    minWidth: 0,
  };

  const textStyle = {
    margin: 0,
    fontSize: "0.9rem",
    color: "#e0e0e0",
    lineHeight: 1.4,
  };

  const usernameStyle = {
    fontWeight: 700,
    color: "#ffffff",
  };

  const timeStyle = {
    color: "rgba(185, 151, 255, 0.6)",
    fontSize: "0.75rem",
    marginTop: "2px",
    display: "block",
  };

  const followingButtonStyle = {
    backgroundColor: "var(--main-purple)",
    color: "#1a1a2e",
    border: "1px solid var(--main-purple)",
    borderRadius: "20px",
    padding: "6px 18px",
    fontSize: "0.8rem",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    flexShrink: 0,
  };

  const followButtonStyle = {
    backgroundColor: "transparent",
    color: "var(--main-purple)",
    border: "1px solid var(--main-purple)",
    borderRadius: "20px",
    padding: "6px 18px",
    fontSize: "0.8rem",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    flexShrink: 0,
  };

  return (
    <div style={cardStyle}>
      {/* AVATAR */}
      <div style={avatarWrapperStyle}>
        <img
          src={avatar}
          alt={`${senderUsername}'s avatar`}
          style={avatarImgStyle}
        />
      </div>

      {/* TEXT */}
      <div style={textContainerStyle}>
        <p style={textStyle}>
          <span style={usernameStyle}>{senderUsername}</span> started following you
        </p>
        <span style={timeStyle}>{timeAgo}</span>
      </div>

      {/* FOLLOW / FOLLOWING BUTTON */}
      <button
        onClick={onFollowBack}
        style={isFollowing ? followingButtonStyle : followButtonStyle}
      >
        {isFollowing ? "Following" : "Follow"}
      </button>
    </div>
  );
}
